// src/app/services/translation-sync.service.ts
import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TranslationSyncService {
  // Map<HTMLElement, translationKey>
  private registry = new Map<HTMLElement, string>();
  private placeholderRegistry = new Map<HTMLInputElement|HTMLTextAreaElement, string>();
  currentLang: any;
  defaultLang: any;

  constructor(private translate: TranslateService) {
    // Bei jedem Sprachwechsel alle registrierten Elemente neu beschriften
    this.translate.onLangChange.subscribe((e: LangChangeEvent) => {
      this.updateAllText();
      this.updateAllPlaceholders();
    });
  }

  /** Meldet ein Element mit zugehörigem Key an */
  register(el: HTMLElement, key: string): void {
    this.registry.set(el, key);
    this.updateText(el,key)
  }

  registerPlaceholderInput(el: HTMLInputElement, key: string): void {
    this.placeholderRegistry.set(el, key);
    el.placeholder = this.translate.instant(key);
  }

  registerPlaceholderTextArea(el: HTMLTextAreaElement, key: string): void {
    this.placeholderRegistry.set(el, key);
    el.placeholder = this.translate.instant(key);
  }


  /** Optional: Entfernt die Registrierung (z.B. wenn Container gelöscht) */
  unregister(el: HTMLElement): void {
    this.registry.delete(el);
    this.placeholderRegistry.delete(el as any);
  }

  /** Update eines einzelnen Elements */
  private updateElement(el: HTMLElement, key: string) {
    const txt = this.translate.instant(key);
    el.innerHTML = txt;
  }

    private updateAllPlaceholders() {
    this.placeholderRegistry.forEach((key, el) => {
      el.placeholder = this.translate.instant(key);
    });
  }

  /** Update aller registrierten Elemente */
  private updateAll() {
    this.registry.forEach((key, el) => this.updateElement(el, key));
  }

    private updateText(el: HTMLElement, key: string) {
    el.innerHTML = this.translate.instant(key);
  }
  private updateAllText() {
    this.registry.forEach((key, el) => this.updateText(el, key));
  }
}
